module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentScreen !== 'welcome'),
      expression: "currentScreen !== 'welcome'"
    }],
    staticClass: "game-top",
    on: {
      "click": function($event) {
        _vm.showModal('top')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_gametop.png"),
      "alt": "game top"
    }
  })]), _vm._v(" "), _c('vue-audio', {
    ref: "btnClick",
    attrs: {
      "file": 3
    }
  }), _vm._v(" "), _c('vue-audio', {
    ref: "audio",
    attrs: {
      "file": _vm.bgmFile,
      "bgm": _vm.bgm,
      "loop": true
    }
  })], 1), _vm._v(" "), (_vm.currentScreen === 'welcome') ? [_c('welcome')] : (_vm._.includes(['card', 'decisionCard', 'specialCard'], _vm.currentScreen)) ? [_c('card')] : (_vm.currentScreen === 'match') ? [_c('match')] : (_vm.currentScreen === 'race') ? [_c('race-screen')] : (_vm.currentScreen === 'result') ? [_c('result')] : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "id": _vm.key,
      "show": _vm.isModal,
      "type": _vm.typeName
    },
    on: {
      "update:show": function($event) {
        _vm.isModal = $event
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64401eb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 84
// module chunks = 0